var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEndcomponent = function SvgEndcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.25c5.364 0 9.643 4.482 9.643 9.9 0 1.871-.597 3.84-1.399 5.667-.81 1.845-1.877 3.652-2.924 5.226a55.348 55.348 0 0 1-2.878 3.926c-.139.173-.27.333-.392.481h8.95v5.8h-22v-5.8h8.95c-.121-.148-.253-.308-.392-.481a55.363 55.363 0 0 1-2.878-3.926c-1.047-1.574-2.114-3.38-2.924-5.226-.802-1.827-1.398-3.796-1.399-5.667 0-5.418 4.279-9.9 9.643-9.9Zm0 8.6c-.62 0-1.214.545-1.214 1.3 0 .756.593 1.3 1.214 1.3.63 0 1.214-.539 1.214-1.3 0-.755-.593-1.3-1.214-1.3Z",
    fill: "#70D6BA",
    stroke: "#E2F7F1",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11.75,
    r: 2,
    fill: "#E2F7F1"
  })));
};
export default SvgEndcomponent;